import { Model } from './model';

export const MAX_SURCHARGE_PERCENTAGE = 2.9;
export const MAX_SURCHARGE_FIXED_CENTS = 30;

export class PaymentSettings extends Model {
  organization_id: string;

  payment_processor: 'stripe' | 'finix' | 'finix_platform';

  credit_card_surcharge: boolean;

  credit_card_surcharge_percentage: string;

  credit_card_surcharge_fixed: number;

  ready_for_payments: boolean;

  partial_payments_enabled: boolean;

  debit_cards_disabled: boolean;

  stripe_connect_account_id?: string;

  finix_merchant_id?: string;
  finix_onboarding_form_id?: string;
  finix_platform_username?: string;
  finix_platform_password?: string;
  finix_platform_application_id?: string;
  finix_platform_merchant_id?: string;
}

export interface UpdatePaymentSettingsInput {
  credit_card_surcharge?: boolean;

  credit_card_surcharge_percentage?: string;

  credit_card_surcharge_fixed?: number;

  partial_payments_enabled?: boolean;

  debit_cards_disabled?: boolean;
}
